import { combineReducers } from 'redux';
import options from './options';
import searchItems from './searchItems';
import order from './order';
import orderAdjustment from './orderAdjustment';

export default combineReducers({
  options,
  searchItems,
  order,
  orderAdjustment
});
